import styled from 'styled-components';

import { Divider } from 'src/app/components/lib/divider';

function getBorderColor(isSelected?: boolean, isError?: boolean) {
  if (isSelected) {
    return 'var(--color-blue-50)';
  }
  if (isError) {
    return 'var(--color-red-30)';
  }
  return 'var(--color-gray-30)';
}

export const StyledBaseNode = styled.div<{ isError?: boolean; isSelected?: boolean }>`
  background-color: var(--color-brand-primary-white);
  color: var(--color-gray-80);
  padding: var(--sizes-30);
  border-radius: var(--sizes-30);
  outline-width: ${(props) => (props.isSelected ? '2px' : '1px')};
  min-width: 320px;
  cursor: pointer;
  outline-style: solid;
  outline-color: ${(props) => getBorderColor(props.isSelected, props.isError)};
`;

export const NodeRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--sizes-20);
`;

export const StyledDivider = styled(Divider)`
  margin-top: var(--sizes-20);
  margin-bottom: var(--sizes-20);
`;

export const StyledLabel = styled.label`
  font: var(--font-extra-small-12pt-semibold);
  color: var(--color-grayscale-black);
  margin: 0;
`;

export const StyledDescription = styled.label`
  font: var(--font-extra-small-12pt-normal);
  color: var(--color-gray-80);
  margin-top: var(--sizes-20);
  margin-bottom: 0;
`;

export const StatsBadgeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font: var(--font-extra-small-12pt-normal);
  text-decoration: underline;
  text-decoration-style: dotted;
  background-color: var(--color-gray-10);
  color: var(--color-gray-80);
  padding: 4px 8px;
  border-radius: 2px;
`;

export const StatsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: default;
`;

export const NodeControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
